import { render, staticRenderFns } from "./FeatureCard2.vue?vue&type=template&id=197cf7b2&scoped=true&"
import script from "./FeatureCard2.vue?vue&type=script&lang=js&"
export * from "./FeatureCard2.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCard2.vue?vue&type=style&index=0&id=197cf7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cf7b2",
  null
  
)

export default component.exports